import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createRouter, createWebHistory } from 'vue-router'
import App from './App.vue'
import TasksView from './views/TasksView.vue'
import MapView from './views/MapView.vue'
import DevicesView from './views/DevicesView.vue'
import AccountView from './views/AccountView.vue'
import MarketplaceView from './views/MarketplaceView.vue'
import Dashboard from './views/Dashboard.vue'
import DashboardView from './views/DashboardView.vue'
import ResearchView from './views/ResearchView.vue'
import ReportsView from './views/ReportsView.vue'

// Import styles
import './assets/styles/main.css'

// Create router
const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      redirect: '/dashboard'
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: DashboardView,
      meta: {
        title: 'Dashboard - AgriFlight'
      }
    },
    {
      path: '/research',
      name: 'Research',
      component: ResearchView,
      meta: {
        title: 'Research & Insights - AgriFlight'
      }
    },
    {
      path: '/reports',
      name: 'Reports',
      component: ReportsView,
      meta: {
        title: 'Reports & Analytics - AgriFlight'
      }
    },
    {
      path: '/tasks',
      name: 'Tasks',
      component: TasksView,
      meta: {
        title: 'Tasks - AgriFlight'
      }
    },
    {
      path: '/map',
      name: 'Map',
      component: MapView,
      meta: {
        title: 'Map - AgriFlight'
      }
    },
    {
      path: '/devices',
      name: 'Devices',
      component: DevicesView,
      meta: {
        title: 'Devices - AgriFlight'
      }
    },
    {
      path: '/marketplace',
      name: 'Marketplace',
      component: MarketplaceView,
      meta: {
        title: 'Marketplace - AgriFlight'
      }
    },
    {
      path: '/account',
      name: 'Account',
      component: AccountView,
      meta: {
        title: 'Account - AgriFlight'
      }
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

// Router navigation guard for page titles
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

// Create pinia store
const pinia = createPinia()

// Create app
const app = createApp(App)

// Use plugins
app.use(pinia)
app.use(router)

// Mount app
app.mount('#app')
